import React from 'react';
import classNames from 'classnames/bind';

import { Switch } from 'components';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const ServiceSwitch = (props) => <div className={cx('switch')}><Switch {...props} /></div>;
